export const CARD_REGISTRATION_STATE = Object.freeze({
    MEMBER_REGISTERABLE: 1,
    MEMBER_REGISTERED: 2,
    OWNER_REGISTERED: 3,
    OWNER_REGISTERABLE: 4,
});

export default CARD_REGISTRATION_STATE;
